import Handsontable from "handsontable";
import Core from "handsontable/core";
import { CellProperties } from "handsontable/settings";
import { MatrixParameterValue } from "../interfaces/MatrixInputCell";
import applyMatrixInputCellFeedback from "./MatrixInputCellFeedback";

const customDropdownRenderer = (
  instance: Core,
  td: HTMLTableCellElement,
  rowIndex: number,
  colIndex: number,
  prop: string | number,
  cell: MatrixParameterValue,
  cellProperties: CellProperties,
) => {
  // See: https://github.com/handsontable/handsontable/issues/10325
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (Handsontable.renderers as any).DropdownRenderer.apply(instance, [
    instance,
    td,
    rowIndex,
    colIndex,
    prop,
    cell,
    cellProperties,
  ]);

  cell.voided ? (td.style.textDecoration = "line-through") : (td.style.textDecoration = "none");
  td.innerHTML = td.innerHTML?.replace("[object Object]", cell.parameterValue.value!);
  applyMatrixInputCellFeedback(td, cellProperties);
};

export default customDropdownRenderer;
